module.exports = __webpack_public_path__ + "static/media/photo8.d6657a66.jpg";